import { IMaskInput } from "react-imask";
import { BrandTextInput } from "./text_input";
import { forwardRef } from "react";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import { colors } from "assets/colors/colors";
export const BrandSearchTextInput = ({ ...props }) => {
  return (
    <BrandTextInput
      {...props}
      placeholder="Search"
      sx={{
        background: colors.core20,
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: colors.core20,
        },
      }}
      color={colors.peach}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ color: colors.core50 }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
